import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const EmptyDrawerIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M22 13.25V4.5C22 3.83696 21.7366 3.20107 21.2678 2.73223C20.7989 2.26339 20.163 2 19.5 2H4.5C3.83696 2 3.20107 2.26339 2.73223 2.73223C2.26339 3.20107 2 3.83696 2 4.5V13.25M22 13.25V19.5C22 20.163 21.7366 20.7989 21.2678 21.2678C20.7989 21.7366 20.163 22 19.5 22H4.5C3.83696 22 3.20107 21.7366 2.73223 21.2678C2.26339 20.7989 2 20.163 2 19.5V13.25M22 13.25H18.7675C18.436 13.2501 18.1181 13.3818 17.8838 13.6163L14.8663 16.6337C14.6319 16.8682 14.314 16.9999 13.9825 17H10.0175C9.68601 16.9999 9.36812 16.8682 9.13375 16.6337L6.11625 13.6163C5.88188 13.3818 5.56399 13.2501 5.2325 13.25H2"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

EmptyDrawerIcon.displayName = 'EmptyDrawerIcon';
